import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CustomerDecisionPage.ErrorCard', {
    title: 'Inaccessible Quote',
    apologize: "We apologize, but the Quote you're looking for is currently inaccessible. This may be due to:",
    reasons: `
        - The Quote has been deleted;{br}
        - The URL's access period has expired.
    `,
    contactUs: 'If you need further assistance or have questions about this Quote, please contact the author.',
});
